// Monovate theme - following official style guide v1.1
export const clientThemeMonavate = {
    mainLayout: {
        backgroundColor: '#f9f8f5', // Off White
        hover: {
            backgroundColor: '#47ecd1', // Aqua
        },
    },
    topBar: {
        backgroundColor: '#202133', // Bold Black
        contrastText: '#f9f8f5', // Off White
        contrastLinkText: '#47ecd1', // Aqua
        userIcon: '#D4F500', // Monavate Yellow
        brandLogo: {
            maxWidth: '175px',
            paddingTop: '0px',
        },
        menuBarIcon: {
            color: '#afafaf',
        },
    },
    sidebar: {
        fontSize: '12px',
        backgroundColor: '#202133', // Bold Black
        darkBackgroundColor: '#202133', // Bold Black
        sideMenuActive: {
            backgroundColor: '#333436',
            contrastText: '',
        },
        sideMenuHover: {
            backgroundColor: '',
            contrastText: '',
        },
    },
    footer: {
        backgroundColor: '',
        contrastText: '',
    },
    charts: {
        fill: '#D4F500', // Monavate Yellow
        stroke: '#202133', // Bold Black
        lineCharts: {
            stroke: '#202133', // Bold Black
            fill: '#D4F500', // Monavate Yellow
        },
        areaCharts: {
            gradient: {
                start: '#D4F500',
                stop: '#D4F500', // Monavate Yellow
            },
            stroke: '#202133', // Bold Black
            fill: '#D4F500', // Monavate Yellow
            chargebacksByPostDateChart: {
                stroke: '#202133', // Bold Black
                fill: '#D4F500', // Monavate Yellow
            },
            newAlertsByDateChart: [
                {
                    stroke: '#202133', // Bold Black
                    fill: 'rgba(32, 33, 51, 0.8)', // Bold Black 80%
                },
                {
                    stroke: '#D4F500', // Monavate Yellow
                    fill: 'rgba(223, 255, 0, 0.8)', // Monavate Yellow 80%
                },
                {
                    stroke: '#47ecd1', // Aqua
                    fill: 'rgba(71, 236, 209, 0.8)', // Aqua 80%
                },
                {
                    stroke: '#7b869e', // Dove Grey
                    fill: 'rgba(123, 134, 158, 0.8)', // Dove Grey 80%
                },
                {
                    stroke: '#dfebee', // Soft Grey
                    fill: 'rgba(223, 235, 238, 0.8)', // Soft Grey 80%
                },
            ],
        },
        barCharts: {
            fill: '#202133', // Bold Black
            byPlatformBarChart: { fill: '#202133' }, // Bold Black
            byBinBarChart: { fill: '#202133' }, // Bold Black
            ertsByRevenueChart: {
                bar1Fill: '#202133', // Bold Black
                bar2Fill: '#47ecd1', // Aqua
            },
        },
        lineBarCharts: {
            byNonUniqueCustomerLineBarChart: {
                barColor: '#D4F500', // Monavate Yellow
                lineColor: '#202133', // Bold Black
            },
        },
        heatmapCharts: {
            casesFiled: {
                low: '#202133',
                mid: '#47ecd1',
                high: '#D4F500',
            },
        },
        pieCharts: {
            defaultPieChart: [
                '#D4F500', // Monavate Yellow
                '#202133', // Bold Black
                '#47ecd1', // Aqua
                '#7b869e', // Dove Grey
                '#dfebee', // Soft Grey
            ],
        },
        radialBarCharts: {
            fill: '#202133', // Bold Black
        },
    },
    lockAndUnlockButton: {
        lockButton: {},
        unlockButton: {},
    },
    lampColors: {
        green: '#47ecd1', // Aqua
        red: '#D4F500', // Monavate Yellow
        orange: '#7b869e', // Dove Grey
        yellow: '#D4F500', // Monavate Yellow
        grey: '#dfebee', // Soft Grey
    },
    uploadDnD: {
        borderColor: '#47ecd1', // Aqua
        backgroundColor: 'rgba(71, 236, 209, 0.2)', // Aqua 20%
        labelColor: '#202133', // Bold Black
    },
    metricTile: {
        arrow: {
            width: 28,
            height: 28,
        },
    },
    caseBuilder: {
        color: '#202133', // Bold Black
        saveAndContinueBtn: {
            margin: '0px',
            fontWeight: 700,
            textTransform: 'capitalize',
            backgroundColor: '#D4F500', // Monavate Yellow

            '&:hover': {
                backgroundColor: 'rgba(223, 255, 0, 0.8)', // Monavate Yellow 80%
            },
        },
        submittingColor: '#47ecd1', // Aqua
    },
    accentAreaTopBorderAccent: {
        backgroundColor: '',
        borderRadius: '',
    },
    dateRangeContainer: {
        borderRadius: '',
        padding: '7px 8px',
    },
    selectionBox: {
        borderRadius: '4px',
    },
    formFields: {
        formLabel: {},
        formText: {
            standard: {
                color: '#263238',
            },
            outlined: {
                fontSize: '',
            },
        },
    },
    labelTags: {
        borderRadius: '16px',
        backgroundColor: '#e0e0e0',
    },
    searchBar: {
        padding: '6px',
    },
    buttons: {
        styleButton: {
            root: {
                textTransform: 'capitalize',
            },
            contained: {
                textTransform: 'capitalize',
            },
        },
        defaultButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#E0E0E0',
                color: 'rgba(0, 0, 0, 0.87)',
                '&:hover': {
                    backgroundColor: '#d5d5d5',
                },
            },
        },
        textOrOutlinedButton: {
            variant: 'outlined',
            style: {
                border: '1px solid #DDE2EB !important',
                borderRadius: '4px !important',
                color: '#263238',
                fontWeight: 600,
                padding: '4px 10px',
                fontSize: '12px',
                '&:hover': {
                    backgroundColor: 'rgba(38, 50, 56, 0.04)',
                },
            },
        },
        greyButton: {
            variant: 'contained',
            style: {
                color: '#4f4f4f',
                backgroundColor: '#D5D5D5',
                '&:hover': {
                    color: '#4f4f4f',
                    backgroundColor: '#D5D5D5',
                },
            },
        },
        greenButton: {
            variant: 'contained',
            style: {
                backgroundColor: '#3ED4AF',
                '&:hover': {
                    backgroundColor: '#3ac5a2',
                },
            },
        },
        activeStateButton: {
            color: 'white',
            backgroundColor: '#61656E',
        },
    },
    icons: {
        uploadIcon: '#3cb4e5',
        dnrAndRevertDnrIcon: '#3cb4e5',
        toggleUnlockIcon: '#75797b',
        toggleLockIcon: '#c80000',
        editUserIcon: '#2a7ea0',
        midPermissionIcon: '#714eb1',
        sitePermissionIcon: '#f88d2b',
        tempPasswordIcon: '#3cb4e5',
    },
    main: '#D4F500',
    primaryLight: '#DCF733',
    primary: '#D4F500',
    primaryDark: '#94AB00',
    primaryText: '#121315',
    secondaryLight: '#6BEFDA',
    secondary: '#47ECD1',
    secondaryDark: '#31A592',
    secondaryText: '#121315',
    hyperlink: '#098fe2',
    textField: '#263238',
    switch: '#D4F500',
    typography: {
        fontColor: {
            primaryText: '',
            secondaryText: '',
        },
        fontFamily: ['Poppins'],
        fontFamilyConfig: {
            primary: 'Poppins',
            fallback: '',
        },
        h1: {
            fontSize: '35px',
        },
        h2: {
            fontSize: '29px',
        },
        h3: {
            fontSize: '24px',
        },
        h4: {
            fontSize: '20px',
        },
        h5: {
            fontSize: '14px',
        },
        h6: {
            fontSize: '14px',
        },
        subtitle1: {
            fontSize: '14px',
        },
        subtitle2: {
            fontSize: '12px',
        },
        subtitle3: {
            fontSize: '12px',
        },
        subtitle4: {
            fontSize: '14px',
        },
        body1: {
            fontSize: '12px',
        },
        body2: {
            fontSize: '10px',
        },
        button1: {
            fontSize: '12px',
        },
        button2: {
            fontSize: '12px',
        },
        caption: {
            fontSize: '11px',
        },
        overline: {
            fontSize: '11px',
        },
        label: {
            fontSize: '12px',
        },
        dataGrid: {
            tableHeader: {
                fontSize: '12.8px',
            },
            tableBody: {
                fontSize: '12px',
                color: '#464646',
            },
            tableExpandable: {
                fontSize: '12px',
            },
        },
    },
}
